import { useContext } from "react";
import CityContext from "../contexts/CityContext";

/**
 * Hook to access city context
 * Returns city data, state, normalized location, loading state, and error
 * @returns {Object} { city, state, normalizedLocation, loading, error }
 */
const useCity = () => {
  const context = useContext(CityContext);

  // If context is undefined or doesn't have expected structure, return safe defaults
  if (!context || typeof context !== "object") {
    return {
      city: null,
      state: null,
      normalizedLocation: null,
      loading: false,
      error: null,
    };
  }

  return context;
};

export default useCity;

